import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const AssignIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Assign`} {...props}>
    <Path
      d="M1 13.5V11.8333C1 10.9493 1.36875 10.1014 2.02513 9.47631C2.6815 8.85119 3.57174 8.5 4.5 8.5H8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      fill="none"
    />
    <Path
      d="M13 14L15 12L13 10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      fill="none"
    />
    <Path
      d="M15 12L9 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      fill="none"
    />
    <Path
      d="M7.5 6C8.88071 6 10 4.88071 10 3.5C10 2.11929 8.88071 1 7.5 1C6.11929 1 5 2.11929 5 3.5C5 4.88071 6.11929 6 7.5 6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      fill="none"
    />
  </Icon>
);
